function mailto(localPart, domain, subject) {
    if (subject) {
        location.href = "mailto:" + localPart + "@" + domain + "?subject=" + subject;
    } else {
        location.href = "mailto:" + localPart + "@" + domain;
    }
}